// dariAlphabet.js
//
// `sound` is a rough Latin transliteration used by the letter lessons.
// `joins` is false for the non-connecting letters (ا آ د ذ ر ز ژ و): these
// never join to the *following* letter, so they have no initial/medial form.

export const dariAlphabet = [
  { dari: 'ا', english: 'Alef', sound: 'ā', joins: false },
  { dari: 'آ', english: 'Alef Madda', sound: 'ā', joins: false },
  { dari: 'ب', english: 'Be', sound: 'b', joins: true },
  { dari: 'پ', english: 'Pe', sound: 'p', joins: true },
  { dari: 'ت', english: 'Te', sound: 't', joins: true },
  { dari: 'ث', english: 'Se', sound: 's', joins: true },
  { dari: 'ج', english: 'Jim', sound: 'j', joins: true },
  { dari: 'چ', english: 'Che', sound: 'ch', joins: true },
  { dari: 'ح', english: 'He (Hotti)', sound: 'h', joins: true },
  { dari: 'خ', english: 'Khe', sound: 'kh', joins: true },
  { dari: 'د', english: 'Dal', sound: 'd', joins: false },
  { dari: 'ذ', english: 'Zal', sound: 'z', joins: false },
  { dari: 'ر', english: 'Re', sound: 'r', joins: false },
  { dari: 'ز', english: 'Ze', sound: 'z', joins: false },
  { dari: 'ژ', english: 'Zhe', sound: 'zh', joins: false },
  { dari: 'س', english: 'Sin', sound: 's', joins: true },
  { dari: 'ش', english: 'Shin', sound: 'sh', joins: true },
  { dari: 'ص', english: 'Sad', sound: 's', joins: true },
  { dari: 'ض', english: 'Zad', sound: 'z', joins: true },
  { dari: 'ط', english: 'Ta', sound: 't', joins: true },
  { dari: 'ظ', english: 'Za', sound: 'z', joins: true },
  { dari: 'ع', english: 'Ain', sound: 'glottal', joins: true },
  { dari: 'غ', english: 'Ghain', sound: 'gh', joins: true },
  { dari: 'ف', english: 'Fe', sound: 'f', joins: true },
  { dari: 'ق', english: 'Qaf', sound: 'q', joins: true },
  { dari: 'ک', english: 'Kaf', sound: 'k', joins: true },
  { dari: 'گ', english: 'Gaf', sound: 'g', joins: true },
  { dari: 'ل', english: 'Lam', sound: 'l', joins: true },
  { dari: 'م', english: 'Meem', sound: 'm', joins: true },
  { dari: 'ن', english: 'Noon', sound: 'n', joins: true },
  { dari: 'و', english: 'Vav', sound: 'w', joins: false },
  { dari: 'ه', english: 'He (Hawwaz)', sound: 'h', joins: true },
  { dari: 'ی', english: 'Ye', sound: 'y', joins: true }
];
